module.exports = __webpack_public_path__ + "static/img/xinNew4.717f124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xinNew4.jpg
// module id = 3JeE
// module chunks = 0